import { SortDirection } from '../SortDirection';

export enum LobbyTableCustomSortingProperty {
  LIVE_PLAYERS = 'Live players',
}

export interface LobbyTableCustomSorting {
  sortProperty?: LobbyTableCustomSortingProperty;
  sortDirection?: SortDirection;
}
